<template>
  <v-layout column align-center>
    <template v-if="!email">
      <v-btn
        width="250"
        color="white"
        class="mb-3"
        style="font-family: roboto;"
        @click="continueWithGoogle({ inviteId })"
      >
        <google-logo></google-logo><span class="">Continue with Google</span>
      </v-btn>
      <v-btn text width="250" @click="email = true" color="grey darken-2">
        <v-icon class="mr-4">email</v-icon>Continue with Email
      </v-btn>
    </template>
    <email-form
      v-else
      @cancel="email = false"
      :inviteId="inviteId"
      @signInStart="$emit('signInStart')"
      @signInSuccess="$emit('signInSuccess')"
      @signInError="$emit('signInError', $event)"
    ></email-form>
  </v-layout>
</template>

<script>
import GoogleLogo from './google-logo';
import EmailForm from './EmailForm';
import 'firebaseui/dist/firebaseui.css';
import { signInWithGoogle } from '@/store/useAuth';

export default {
  data() {
    return {
      email: false
    };
  },
  components: { GoogleLogo, EmailForm },
  props: {
    id: { default: 'auth' },
    inviteId: {}
  },
  mounted() {
    //this.firebaseUiRegister(`#${this.id}`);
  },
  // watch: {
  //   isUser: function(n) {
  //     if (!n) {
  //       this.ui.start();
  //     } else {
  //       this.ui.reset();
  //     }
  //   }
  // },
  methods: {
    continueWithGoogle() {
      this.$emit('signInStart');
      signInWithGoogle({ inviteId: this.inviteId })
        .then(() => {
          console.log('sign in success');
          this.$emit('signInSuccess');
        })
        .catch(e => {
          console.log(e);
          this.$emit('signInError');
        });
    }
  }
};
</script>

<style></style>
